import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TranslateService } from './translate.service';
import { Subscription } from 'rxjs';

@Pipe({ name: 't', pure: false })
export class TranslatePipe implements PipeTransform, OnDestroy {
  private sub: Subscription;
  constructor(private ts: TranslateService, private cd: ChangeDetectorRef) {
    // subscribe to language changes to trigger change detection
    this.sub = this.ts.getLang$().subscribe(() => this.cd.markForCheck());
  }

  transform(key: string): string {
    return this.ts.t(key);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
